import classNames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'

import { Loading } from '../Loading'
import styles from './Button.module.scss'

export const Button = (props) => {
  const {
    colorScheme = 'primary',
    variant = 'solid',
    size = 'md',
    isDisabled = false,
    fluid = false,
    loading,
    children,
    selected = false,
    className = '',
    tabIndex,
    ...rest
  } = props

  const buttonClass = classNames(styles.buttonBase, {
    [styles[colorScheme]]: colorScheme,
    [styles[variant]]: variant,
    [styles[size]]: size,
    [styles.disabled]: isDisabled || loading,
    [styles[fluid ? 'fluid' : '']]: fluid,
    [styles.selected]: selected,
    [className || '']: className,
  })

  const uniqueId = typeof children === 'string' ? children : ''

  return !loading ? (
    <button
      className={buttonClass}
      disabled={isDisabled}
      tabIndex={tabIndex}
      {...rest}
      data-testid={`auto-id-cf2ba11c-91a6-46b2-8ac6-89dbab59237b-${uniqueId.toLowerCase()}`}
    >
      {children}
    </button>
  ) : (
    <div
      className={buttonClass}
      data-testid={`auto-id-710a0e15-aa1c-4cca-a195-3a43865285d5-${uniqueId.toLowerCase()}`}
    >
      <Loading variant="circle" />
    </div>
  )
}

Button.propTypes = {
  colorScheme: PropTypes.oneOf([
    'primary',
    'inverted',
    'secondary',
    'tertiary',
    'negative',
  ]),
  variant: PropTypes.oneOf(['solid', 'outline', 'ghost', 'text', 'inverted']),
  size: PropTypes.oneOf(['xs', 'sm', 'md', 'lg']),
  isDisabled: PropTypes.bool,
  fluid: PropTypes.bool,
  loading: PropTypes.bool,
  children: PropTypes.node,
  selected: PropTypes.bool,
  className: PropTypes.string,
  onClick: PropTypes.func,
  id: PropTypes.string,
  tabIndex: PropTypes.number,
}
